"use client";

import { metadata } from "@/data";

function Copyright() {
  return (
    <p className="text-xs text-gray-500 text-center md:text-left">
      &copy; {new Date().getFullYear()} {metadata.author.name}. All rights reserved.
    </p>
  );
}

export default Copyright;